<template>
  <div>
      <v-layout wrap row justify-start pa-2>
        <v-flex xs12 md12 px-2 pb-2 v-if="superAdmin || userRole == 'admin'">
          <v-card class="elevation-24">
            <v-card-title :class="`headline white--text ${active ?'success' : 'error'}`">
							Q Reports
              <v-spacer></v-spacer>
              <v-autocomplete
                :items="ousers"
                solo
                :disabled="loading"
                :loading="loading"
                return-object
                hide-details
                v-model="selectedUser"
                label="User"
                @change="loadQUser()"
                item-text="name"
              ></v-autocomplete>
              <!-- <v-menu
                v-model="fdate"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template slot="activator">
                  <v-text-field
                    v-model="fromDate"
                    label="From Date"
                    append-icon="event"
                    readonly
                    solo
                    class="px-1"
                    hide-details
                    clearable
                    :loading="loading"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="fromDate" @input="fdate = false"></v-date-picker>
              </v-menu>
              <v-menu
                v-model="tdate"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template slot="activator">
                  <v-text-field
                    v-model="toDate"
                    label="To Date"
                    append-icon="event"
                    readonly
                    solo
                    class="px-1"
                    hide-details
                    clearable
                    :loading="loading"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="fromDate" @input="tdate = false"></v-date-picker>
              </v-menu> -->
              <v-btn 
                color="secondary" :loading="loading" :disabled="loading" @click="adminPanel = !adminPanel">toggle
              </v-btn>
						</v-card-title>
            <v-card-text v-if="adminPanel">
              <v-layout row wrap>
                <v-flex xs12 px-2 pb-2 v-if="loadedUser">
                  <v-layout row wrap align-center>
                    <v-flex xs6 md2>
                      {{loadedUser.username}}
                    </v-flex>
                    <v-flex xs3 md2>
                      <v-btn color="success" @click="exportUserTime(loadedUser)">export</v-btn>
                    </v-flex>
                    <v-flex xs3 md2>
                      <v-btn color="success" @click="exportUserWTime(loadedUser)">export wa log</v-btn>
                    </v-flex>
                    <v-flex xs3 md2>
                      <v-btn color="success" @click="exportUserDaily(loadedUser)">export Daily count</v-btn>
                    </v-flex>
                    <v-flex xs6 md3 v-if="false">
                      <v-layout row wrap>
                        <v-flex xs12 v-for="(se, s) in Object.values(loadedUser.sessions)" :key="s+'session'">
                          <div>{{se.day}}/{{se.month}}/{{se.year}} -> Time: {{msToTime(se.session)}}</div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs6 md3 v-if="false">
                      <v-layout row wrap>
                        <v-flex xs12 v-for="(day, s) in getDayArray(loadedUser.sessions)" :key="s+'dat'">
                          <div>{{day.day}}/{{day.month}} -> Time: {{msToTime(day.session)}}</div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs6 md3 v-if="false">
                      <v-layout row wrap>
                        <v-flex xs12 v-for="(month, s) in getMonthArray(loadedUser.sessions)" :key="s+'month'">
                          <div>{{month.month}} -> Time: {{msToTime(month.session)}}</div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs6 md6 px-2 pb-2 v-if="false">
          <v-card class="elevation-24">
            <v-card-title :class="`headline white--text ${active ?'success' : 'error'}`">
							Q Live
              <v-spacer></v-spacer>
              <v-btn 
                color="success" :loading="loading" :disabled="loading" @click="realTimeQ()">start
              </v-btn>
              <v-btn 
                color="secondary" :loading="loading" :disabled="loading" @click="livePanel = !livePanel">toggle
              </v-btn>
						</v-card-title>
            <v-card-text v-if="livePanel">
              <v-layout row wrap>
                <v-flex xs12 px-2 pb-2 v-for="(qtims) in live_q" :key="qtims.key">
                  <v-layout row wrap align-center>
                    <v-flex xs3 px-1 style="font-size:9px;">
                      {{ qtims.key }}
                    </v-flex>
                    <v-flex xs1 px-1 class="text-xs-center">
                      <v-avatar
                        size="10"
                        :color="`${qtims.assigned?'success':'error'}`"
                      >
                      </v-avatar>
                    </v-flex>
                    <v-flex xs2 px-1 class="text-xs-center">
                      {{ qtims.status }}
                    </v-flex>
                    <v-flex xs2 px-1 class="text-xs-center">
                      <span v-if="qtims.w">{{  qtims.w.status }}</span>
                    </v-flex>
                    <v-flex xs2 px-1>
                      <v-btn color="success" small @click="getConv(qtims)">get wa
                      </v-btn>
                    </v-flex>
                    <v-flex xs2 px-1 v-if="qtims.w" class="text-xs-center">
                      <v-icon color="success" v-if="qtims.w.status == qtims.status">done</v-icon>
                      <v-icon color="error" v-if="qtims.w.status != qtims.status">close</v-icon>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 md4 px-2 pb-2 QDB>
          <v-card class="elevation-24">
            <v-card-title :class="`headline white--text ${active ?'success' : 'error'}`">
							Q DB
              <v-spacer></v-spacer>
              <v-btn color="secondary" :loading="loading" :disabled="loading" @click="counterPanel = !counterPanel">toggle
              </v-btn>
						</v-card-title>
            <v-card-text v-if="counterPanel">
              <v-layout row wrap>
                <v-flex xs12 px-2 pb-2 class="text-md-center">
                  <v-layout row wrap>
                    <v-flex xs12 v-for="(key, k) in Object.keys(counters)" :key="k+'-counter'">
                      <v-chip label small color="error" class="white--text">{{key.toUpperCase()}}: {{ counters[key] }}</v-chip>
                    </v-flex>
                    <v-flex xs12>
                      <v-chip label small 
                        v-if="user && GetToday(user).count"
                        :color="`${user.punchin.active ? 'success' : 'error'}`" class="white--text">
                        MSGS: {{GetToday(user).date}} | {{GetToday(user).count}}</v-chip>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 px-2 pb-2 class="text-md-center">
                  <v-avatar
                    size="15"
                    class="mx-1"
                    :color="FBON ? 'success' : 'error'"
                  >
                  </v-avatar>
                  FACEBOOK LOGIN
                </v-flex>
                <v-flex xs12 px-2 pb-2 >
                  <v-layout row wrap v-if="users" class="text-xs-left">
                    <v-flex xs12 v-for="(key, k) in Object.keys(users).filter(x=>users[x].punchin && users[x].username)" :key="k+'-user'" elevation-2 mb-1 pa-2>
                      <div><v-chip label small 
                        v-if="users[key] && users[key].punchin"
                        :color="`${users[key].punchin.active ? 'success' : 'error'}`" class="white--text">
                        USER: {{users[key].username}} 
                        <span v-if="users[key].q"> | Q: {{Object.keys(users[key].q).length}}</span></v-chip></div>
                      <div><v-chip label small 
                        v-if="users[key] && GetToday(users[key]).count"
                        :color="`${users[key].punchin.active ? 'success' : 'error'}`" class="white--text">
                        MSGS: {{GetToday(users[key]).date}} | {{GetToday(users[key]).count}}</v-chip></div>
                      <div><v-btn v-if="users[key] && users[key].punchin" color="success" small @click="resetUserSession(key)">reset</v-btn></div>
                      <div><v-btn v-if="users[key] && users[key].punchin" :disabled="!users[key].punchin.active" color="success" small @click="manualPushout(key)">pushout</v-btn></div>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 px-2 pb-2 v-if="superAdmin || userRole == 'admin'">
                  <v-text-field
                    label="Days"
                    v-model="daysToGet"
                    solo
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 px-2 pb-2 v-if="superAdmin || userRole == 'admin'">
                  <v-btn color="success" small @click="getWANEED()" flat block>get all need reply</v-btn>
                </v-flex>
                <v-flex xs12 px-2 pb-2 v-if="superAdmin || userRole == 'admin'">
                  <v-btn color="success" small @click="markAsReadWANEED()" flat block>ignore all need reply</v-btn>
                </v-flex>
                <v-flex xs12 px-2 pb-2 v-if="superAdmin || userRole == 'admin'">
                  <v-btn color="success" small @click="reAssignAll()" flat block>reassign all</v-btn>
                </v-flex>
                <v-flex xs12 px-2 pb-2 v-if="superAdmin || userRole == 'admin'">
                  <v-btn color="success" small @click="deAssignQ()" flat block>deassign inactive</v-btn>
                </v-flex>
                <v-flex xs12 px-2 pb-2 v-if="superAdmin || userRole == 'admin'">
                  <v-btn color="success" small @click="patrolUsers()" flat block>patrol users</v-btn>
                </v-flex>
                <v-flex xs12 px-2 pb-2 v-if="superAdmin || userRole == 'admin'">
                  <v-btn color="success" small @click="monitorLast()" flat block>monitor in active users</v-btn>
                </v-flex>
                <v-flex xs12 px-2 pb-2 v-if="superAdmin || userRole == 'admin'">
                  <v-btn color="success" small @click="resetCounters()" flat block>reset counter</v-btn>
                </v-flex>
                <v-flex xs12 px-2 pb-2 v-if="superAdmin || userRole == 'admin'">
                  <v-btn color="success" small @click="resetQ()" flat block>reset Q</v-btn>
                </v-flex>
                <v-flex xs12 px-2 pb-2 v-if="superAdmin || userRole == 'admin'">
                  <v-btn color="success" small @click="resetGrandQ()" flat block>reset all</v-btn>
                </v-flex>
                <v-flex xs12 px-2 pb-2 v-if="!active">
                  <v-btn block color="primary" large dark @click="userPunchin()">Punch in</v-btn>
                </v-flex>
                <v-flex xs12 px-2 pb-2 v-if="active">
                  <v-btn block color="error" large dark @click="userPunchOut()">Punch out</v-btn>
                </v-flex>
                <v-flex xs12 px-2 pb-2 v-if="active">
                  <v-progress-circular size="50" :value="timeout*100/resettimeout"></v-progress-circular>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 md8 px-2 pb-2 Q v-if="active || beta">
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Q
              <v-spacer></v-spacer>
              <v-btn color="secondary" :loading="loading" :disabled="loading" @click="qPanel = !qPanel">toggle
              </v-btn>
						</v-card-title>
            <v-card-text v-if="qPanel">
              <v-layout row wrap>
                <v-flex xs12 v-for="(ob, i) in display_q_sort" :key="'itemQ-' + i">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-expansion-panel outset>
                        <v-expansion-panel-content>
                          <div slot="header">
                            <v-layout row wrap>
                              <v-flex xs6>
                                <div><v-chip label color="primary" class="white--text">Title: {{ob.q.title.toUpperCase()}}</v-chip></div>
                                <div><v-chip label small color="primary" class="white--text">Type: {{ob.q.type.toUpperCase()}}</v-chip></div>
                              </v-flex>
                              <v-flex xs6 class="text-xs-right">
                                <div><v-chip label small color="primary" class="white--text">Qued: {{ ob.q.d_time }}</v-chip></div>
                                <div><v-chip label small color="error" class="white--text">Assigned: {{ ob.q.d_assigned }}</v-chip></div>
                              </v-flex>
                            </v-layout>
                          </div>
                          <v-card v-if="ob.type == 'whatsapp'">
                            <v-layout row wrap class="pa-0 ma-0">
                              <v-flex xs12 class="pa-0 ma-0">
                                <v-btn color="success" v-if="!ob.show" flat block @click="ob.show = true">load</v-btn>
                              </v-flex>
                              <v-flex xs12 class="pa-0 ma-0">
                                <waChatNew 
                                  :height="300"
                                  :userName="userName" 
                                  :qitem="ob"
                                  :itemO="i"
                                  @removeItem="removeFromQ"
                                  :userRole="userRole" 
                                  :beta="beta" 
                                  :superAdmin="superAdmin" 
                                  :embed="true" 
                                  v-if="ob.show"
                                  :number="ob.item.number.toString()"/>
                              </v-flex>
                            </v-layout>
                          </v-card>
                          <v-card v-if="ob.type == 'facebook_comment'" >
                            <v-layout row wrap class="pa-0 ma-0">
                              <v-flex xs12 class="pa-0 ma-0">
                                <v-btn color="success" flat block @click="()=>{
                                    ob.show = true; 
                                    ob.post = true;
                                    ob.comment = true;
                                    renderFB(ob, i)
                                  }"
                                >load </v-btn>
                              </v-flex>
                              <v-flex xs6 v-if="ob.show && ob.post" class="pa-0 ma-0 text-xs-center" :id="ob.item.post_id + '-post' + i">
                                <div class="fb-post" :data-href="encodeURI(ob.item.link)" data-width="400" data-show-text="true"></div>
                              </v-flex>
                              <v-flex xs6 v-if="ob.show && ob.comment" class="pa-0 ma-0 text-xs-center" 
                                :id="ob.item.post_id + '-comment' + i">
                                <div class="fb-comment-embed" :data-href="`${ob.item.link}?comment_id=${ob.item.comment_id}`" data-width="400" data-include-parent="true"></div>
                                <v-btn color="success" flat block @click="openFBLink(ob.item.link)"
                                >open post</v-btn>
                                <v-btn color="error" flat block @click="deleteComment(ob.item)"
                                >delete comment</v-btn>
                                <v-btn color="error" flat block @click="hideComment(ob.item)"
                                >hide comment</v-btn>
                              </v-flex>
                              <v-flex xs12 class="pa-0 ma-0 text-xs-center">
                                <v-textarea
                                  solo
                                  hide-details
                                  label="Reply Comment"
                                  v-model="ob.item.reply"
                                ></v-textarea>
                              </v-flex>
                              <v-flex xs12 class="pa-0 my-1 text-xs-center">
                                <v-textarea
                                  name="Reply"
                                  solo
                                  hide-details
                                  label="Reply Message"
                                  v-model="ob.item.message"
                                ></v-textarea>
                              </v-flex>
                              <v-flex xs12 class="pa-0 ma-0 text-xs-center">
                                <v-btn color="success" :disabled="!ob.item.reply" flat block @click="sendReply(ob.item)">send</v-btn>
                              </v-flex>
                            </v-layout>
                          </v-card>
                          <v-card v-if="ob.type == 'facebook_message'" >
                            <v-layout row wrap class="pa-0 ma-0">
                              <v-flex xs12 class="pa-0 ma-0">
                                <v-btn color="success" v-if="!ob.show" flat block @click="ob.show = true">load</v-btn>
                              </v-flex>
                              <v-flex xs12 class="pa-0 ma-0">
                                <fbChat 
                                  :height="300"
                                  :userName="userName" 
                                  :qitem="ob"
                                  :itemO="i"
                                  @removeItem="removeFromQ"
                                  :userRole="userRole" 
                                  :beta="beta" 
                                  :superAdmin="superAdmin" 
                                  :embed="true" 
                                  v-if="ob.show"
                                  :item="ob.item"/>
                              </v-flex>
                            </v-layout>
                          </v-card>
                          <v-card v-if="ob.type == 'instagram_comment'" >
                            <v-layout row wrap class="pa-0 ma-0">
                              <v-flex xs12 class="pa-0 ma-0">
                                <v-btn color="success" flat block @click="()=>{
                                    ob.show = true; 
                                    ob.post = true;
                                    ob.comment = true;
                                    renderFB(ob, i)
                                  }"
                                >load </v-btn>
                              </v-flex>
                              <v-flex xs12 class="pa-0 ma-0 text-xs-center">
                                <blockquote class="instagram-media" data-instgrm-captioned :data-instgrm-permalink="`https://instagram.com/p/${ob.item.media_code}`" data-instgrm-version="13" style=" background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:540px; min-width:326px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"><div style="padding:16px;"> <a :href="ob.item.permalink" style=" background:#FFFFFF; line-height:0; padding:0 0; text-align:center; text-decoration:none; width:100%;" target="_blank"> <div style=" display: flex; flex-direction: row; align-items: center;"> <div style="background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 40px; margin-right: 14px; width: 40px;"></div> <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center;"> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 100px;"></div> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 60px;"></div></div></div><div style="padding: 19% 0;"></div> <div style="display:block; height:50px; margin:0 auto 12px; width:50px;"><svg width="50px" height="50px" viewBox="0 0 60 60" version="1.1" xmlns="https://www.w3.org/2000/svg" xmlns:xlink="https://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-511.000000, -20.000000)" fill="#000000"><g><path d="M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657 M541,33.886 C532.1,33.886 524.886,41.1 524.886,50 C524.886,58.899 532.1,66.113 541,66.113 C549.9,66.113 557.115,58.899 557.115,50 C557.115,41.1 549.9,33.886 541,33.886 M565.378,62.101 C565.244,65.022 564.756,66.606 564.346,67.663 C563.803,69.06 563.154,70.057 562.106,71.106 C561.058,72.155 560.06,72.803 558.662,73.347 C557.607,73.757 556.021,74.244 553.102,74.378 C549.944,74.521 548.997,74.552 541,74.552 C533.003,74.552 532.056,74.521 528.898,74.378 C525.979,74.244 524.393,73.757 523.338,73.347 C521.94,72.803 520.942,72.155 519.894,71.106 C518.846,70.057 518.197,69.06 517.654,67.663 C517.244,66.606 516.755,65.022 516.623,62.101 C516.479,58.943 516.448,57.996 516.448,50 C516.448,42.003 516.479,41.056 516.623,37.899 C516.755,34.978 517.244,33.391 517.654,32.338 C518.197,30.938 518.846,29.942 519.894,28.894 C520.942,27.846 521.94,27.196 523.338,26.654 C524.393,26.244 525.979,25.756 528.898,25.623 C532.057,25.479 533.004,25.448 541,25.448 C548.997,25.448 549.943,25.479 553.102,25.623 C556.021,25.756 557.607,26.244 558.662,26.654 C560.06,27.196 561.058,27.846 562.106,28.894 C563.154,29.942 563.803,30.938 564.346,32.338 C564.756,33.391 565.244,34.978 565.378,37.899 C565.522,41.056 565.552,42.003 565.552,50 C565.552,57.996 565.522,58.943 565.378,62.101 M570.82,37.631 C570.674,34.438 570.167,32.258 569.425,30.349 C568.659,28.377 567.633,26.702 565.965,25.035 C564.297,23.368 562.623,22.342 560.652,21.575 C558.743,20.834 556.562,20.326 553.369,20.18 C550.169,20.033 549.148,20 541,20 C532.853,20 531.831,20.033 528.631,20.18 C525.438,20.326 523.257,20.834 521.349,21.575 C519.376,22.342 517.703,23.368 516.035,25.035 C514.368,26.702 513.342,28.377 512.574,30.349 C511.834,32.258 511.326,34.438 511.181,37.631 C511.035,40.831 511,41.851 511,50 C511,58.147 511.035,59.17 511.181,62.369 C511.326,65.562 511.834,67.743 512.574,69.651 C513.342,71.625 514.368,73.296 516.035,74.965 C517.703,76.634 519.376,77.658 521.349,78.425 C523.257,79.167 525.438,79.673 528.631,79.82 C531.831,79.965 532.853,80.001 541,80.001 C549.148,80.001 550.169,79.965 553.369,79.82 C556.562,79.673 558.743,79.167 560.652,78.425 C562.623,77.658 564.297,76.634 565.965,74.965 C567.633,73.296 568.659,71.625 569.425,69.651 C570.167,67.743 570.674,65.562 570.82,62.369 C570.966,59.17 571,58.147 571,50 C571,41.851 570.966,40.831 570.82,37.631"></path></g></g></g></svg></div><div style="padding-top: 8px;"> <div style=" color:#3897f0; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:550; line-height:18px;"> View this post on Instagram</div></div><div style="padding: 12.5% 0;"></div> <div style="display: flex; flex-direction: row; margin-bottom: 14px; align-items: center;"><div> <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(0px) translateY(7px);"></div> <div style="background-color: #F4F4F4; height: 12.5px; transform: rotate(-45deg) translateX(3px) translateY(1px); width: 12.5px; flex-grow: 0; margin-right: 14px; margin-left: 2px;"></div> <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(9px) translateY(-18px);"></div></div><div style="margin-left: 8px;"> <div style=" background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 20px; width: 20px;"></div> <div style=" width: 0; height: 0; border-top: 2px solid transparent; border-left: 6px solid #f4f4f4; border-bottom: 2px solid transparent; transform: translateX(16px) translateY(-4px) rotate(30deg)"></div></div><div style="margin-left: auto;"> <div style=" width: 0px; border-top: 8px solid #F4F4F4; border-right: 8px solid transparent; transform: translateY(16px);"></div> <div style=" background-color: #F4F4F4; flex-grow: 0; height: 12px; width: 16px; transform: translateY(-4px);"></div> <div style=" width: 0; height: 0; border-top: 8px solid #F4F4F4; border-left: 8px solid transparent; transform: translateY(-4px) translateX(8px);"></div></div></div> <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center; margin-bottom: 24px;"> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 224px;"></div> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 144px;"></div></div></a><p style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; line-height:17px; margin-bottom:0; margin-top:8px; overflow:hidden; padding:8px 0 7px; text-align:center; text-overflow:ellipsis; white-space:nowrap;"><a :href="ob.item.permalink" style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:normal; line-height:17px; text-decoration:none;" target="_blank">POST</a></p></div></blockquote>
                              </v-flex>
                            </v-layout>
                          </v-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" v-if="beta" @click="pushToQ()">test push</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
  </div>
</template>

<script>
import { firebase, db, auth, createFirebase, store } from '@/fb';
import { getRandomInt, randomString, getCDate, sleep} from '@/customFunction';
import {instagramIdToUrlSegment, urlSegmentToInstagramId} from 'instagram-id-to-url-segment'
import axios from 'axios';
import json2csv from 'json2csv'
let apiBase = 'https://us-central1-ashyaatcrm.cloudfunctions.net/main'
const headers = {'Accept': 'application/json'};
import waChatNew from './waChatNew'
import fbChat from './fbChat'
import { format, render, cancel, register } from 'timeago.js';

export default {
  components:{
    waChatNew, fbChat
  },
  data(){
    return {
      loading:false,
      users:[],
      user:null,
      update:null,
      active:false,
      punchin:null,
      q:[],
      display_q:[],
      show:[],
      resettimeout: 1*60*100,
      timeout:this.resettimeout * 1,
      timeoutInterval:null,
      counters:{},
      punchinTime:null,
      daysToGet:1,
      adminPanel:false,
      counterPanel:true,
      qPanel:true,
      fromDate:null,
      fdate:false,
      tdate:false,
      toDate:null,
      selectedUser:null,
      loadedUser:null,
      ousers:[],
      newLoad:false,
      livePanel:false,
      live_q:{},
      FBON:false,
    }
  },
  methods: {
    GetToday(user) {
      let d = new Date().getDate()
      let m = new Date().getMonth() + 1
      return {
        date:`${d}-${m}`,
        count:user && user.msgs && user.msgs[`${d}-${m}`] ? user.msgs[`${d}-${m}`] : 0
      }
    },
    genKey(type){
      let vtoken = `ASHYAAT_${type}_${randomString(22, 'aA#')}`
      return vtoken
    },
    getDayArray(s){
      function getSum(total, num) {
        return total + parseFloat(num);
      }
      let sessions = Object.values(s)
      let days = sessions.map(x=>x.day)
      let months = sessions.map(x=>x.month)
      let mo = []
      let da = []
      months.forEach(m=>{ if(!mo.includes(m)) mo.push(m) })
      days.forEach(d=>{ if(!da.includes(d)) da.push(d) })
      let ar = []
      mo.forEach(m=>{
        da.forEach(d=>{
          let t = sessions.filter(x=>x.day == d && x.month == m).filter(x=>x.session).reduce((a, {session})=> a + session, 0)
          ar.push({day:d, month:m, session:t})
        })
      })
      return ar
    },
    getMonthArray(s){
      function getSum(total, num) {
        return total + parseFloat(num);
      }
      let sessions = Object.values(s)
      let months = sessions.map(x=>x.month)
      let mo = []
      months.forEach(m=>{ if(!mo.includes(m)) mo.push(m) })
      let ar = []
      mo.forEach(m=>{
        let t = sessions.filter(x=>x.month == m).filter(x=>x.session).reduce((a, {session})=> a + session, 0)
        ar.push({month:m, session:t})
      })
      return ar
    },
    msToTime(s) {
      // Pad to 2 or 3 digits, default is 2
      function pad(n, z) {
        z = z || 2;
        return ('00' + n).slice(-z);
      }

      var ms = s % 1000;
      s = (s - ms) / 1000;
      var secs = s % 60;
      s = (s - secs) / 60;
      var mins = s % 60;
      var hrs = (s - mins) / 60;

      return pad(hrs) + ':' + pad(mins) + ':' + pad(secs) + '.' + pad(ms, 3);
    },
    clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    removeFromQ(i){
      this.display_q_sort.splice(i, 1)
    },
    async resetUserSession(key) {
      console.log(key)
      await db.ref(`quusers/${key}`).update({
        current:'frontreset',
      })
    },
    async manualPushout(key){
      await this.userPunchOut(false, key)
    },
    async getAllWANeed() {
      return new Promise(async (resolve, rej)=>{
        let d = this.daysToGet
        let startDate = new Date().getTime() - parseInt(d) * 24 * 60 * 60 * 1000
        let m = await store.collection(`waconversations`)
          .where('need', '==', true)
          .where('last_message', '>', startDate)
          .get().then(x => x.docs.map(y => {
            return {
              ...y.data(),
              key: y.id
            }
          }))
        console.log('all need', m)
        resolve(m)
      })
    },
    async getWANEED(){
      return new Promise(async (resolve, reject)=>{
        let a = await this.getAllWANeed();
        (async x=>{
          for (let i = 0; i < a.length; i++) {
            const conv = a[i];
            await this.organisePushQ(conv)
          }
          resolve({status:true})
        })()
      })
    },
    async markAsReadWANEED(){
      return new Promise(async (resolve, reject)=>{
        let a = await this.getAllWANeed();
        (async x=>{
          for (let i = 0; i < a.length; i++) {
            const conv = a[i];
            await store.collection(`waconversations`).doc(conv.key)
            .update({
              need:false,
            })
            console.log(conv.key, 'done', true)
          }
          resolve({status:true})
        })()
      })
    },
    async organisePushQ(conv){
      return new Promise(async (resolve, reject)=>{
        try {
          console.log('gotten conv', conv)
          if(conv.number) {
            let c = {
              type:'whatsapp',
              assigned:false,
              open:false,
              db:conv.key,
              title: conv.number.toString(),
              time: conv.last_message,
              timezone:  new Date().getTimezoneOffset(),
              status: conv.status
            }
            let search = await db.ref(`quitems`).orderByChild('db').equalTo(c.db).once('value').then(x=>x.val())
            console.log(search)
            if(!search) {
              console.log(c)
              let k = await db.ref(`quitems`).push(c)
              await db.ref(`q/q`).transaction(function (current_value) {
                return (current_value || 0) + 1;
              });
              await db.ref(`quitems/${k.key}`).update({key:k.key})
              resolve(true)
            } else {
              let qed = Object.values(search)
              let fqed = qed[0]
              if(c.status != fqed.status) {
                await db.ref(`quitems/${fqed.key}`).update({status:c.status})
              }
              console.log('found', search, c)
              console.log('already in Q')
              resolve(true)
            }
          } else {
            resolve(true)
            console.log('conv no number', conv);
          }
        } catch (error) {
          resolve(true)
          console.log(error);
          console.log('error conv', conv);
        }
      })
    },
    async pushToQ(){
      let k = await db.ref(`quitems`).push({
        type:'whatsapp',
        assigned:false,
        open:false,
        db:'K8TB2KS5GVqZGS3wzrnZ',
        title: '21651721825',
        time: new Date().getTime(),
        timezone:  new Date().getTimezoneOffset(),
        status: 'Satisfied'
      })
      await db.ref(`q/q`).transaction(function (current_value) {
        return (current_value || 0) + 1;
      });
      await db.ref(`quitems/${k.key}`).update({key:k.key})
    },
    async patrolUsers(){
      let u = await db.ref(`quusers`).orderByChild('punchin/active').equalTo(false).once('value').then(x=>x.val())
      if(u){
        let k = Object.keys(u)
        let users = Object.values(u).map((x, i)=>{return{...x, key:k[i]}}).filter(x=>x.q)
        console.log(users)
        if(users.length){
          (async x=>{
            for (let i = 0; i < users.length; i++) {
              const user = users[i];
              let q = Object.values(user.q).map(x=>x.key)
              await db.ref(`quusers/${this.$props.userData.uid}/`).update({q:null});
              (async x=>{
                for (let i = 0; i < q.length; i++) {
                  const key = q[i];
                  await db.ref(`quitems/${key}`).update({assigned:false, user:null, assigned_at:null})
                  await db.ref(`q/assigned`).transaction(function (current_value) {
                    return (current_value || 0) - 1;
                  });
                }
              })()
            }
          })()
        }
      }
    },
    async checkActive(){
      return new Promise(async (resolve, rej)=>{
        let on = await db.ref('settings/q/active').once('value').then(x=>x.val())
        let u = await db.ref(`quusers`).orderByChild('punchin/active').equalTo(true).once('value').then(x=>x.val())
        if(u && on) resolve(true)
        else resolve(false)
      })
    },
    async reAssignAll(){
      if(await this.checkActive()){
        console.log('active')
        let rQ = await db.ref(`quitems`).orderByChild('assigned').equalTo(false).once('value').then(x=>x.val())
        console.log(rQ)
        if(rQ){
          (async x=>{
            let lrQk = Object.keys(rQ)
            let lrQ = Object.values(rQ).map((x, i)=>{return{...x, key:lrQk[i]}})
            lrQ = lrQ.sort((a, b)=>  b.time - a.time)
            for (let i = 0; i < lrQ.length; i++) {
              const item = lrQ[i];
              try {
                await this.organiseQ(item, item.key)
              } catch (error) {console.log(error)}
            }
          })()
        }
      }
    },
    async monitorQ(){
      let q  = await db.ref(`quitems`).on('child_added', snap =>{
        let item = snap.val()
        this.organiseQ(item, snap.key)
      })
    },
    async organiseQ(item, key) {
      return new Promise(async (resolve, reject)=>{
        console.log('new assign')
        let u = await db.ref(`quusers`).orderByChild('punchin/active').equalTo(true).once('value').then(x=>x.val())
        if(u) {
          try {
            let k = Object.keys(u)
            let au = Object.values(u).map((x, i)=>{return{...x,key:k[i]}})
            let aun = au.filter(x=> !x.q).filter(x=>{
              if(item.status) {
                if(x.wa && x.wa.length && x.wa.includes(item.status))  return true
              } else {
                return false
              }
            })
            let aus = au.filter(x=> x.q).filter(x=>{
              if(item.status) {
                if(x.wa && x.wa.length && x.wa.includes(item.status))  return true
              } else {
                return false
              }
            }).filter(x=> Object.keys(x.q).length < 10)
            if(aun.length){
              let user = aun[0]
              await db.ref(`quitems/${key}`).update({assigned:true, user:user.key, assigned_at:new Date().getTime()})
              await db.ref(`quusers/${user.key}/q`).push({key})
              if(item.type == 'whatsapp') {
                let w = await store.collection(`waconversations`).doc(item.db).update({assigned_user:user.key})
              }
              await db.ref(`q/assigned`).transaction(function (current_value) {
                return (current_value || 0) + 1;
              });
              resolve({status:true, user})
            } else if(aus.length){
              let sau = aus.sort((a, b)=> Object.values(a.q).length - Object.values(b.q).length)
              console.log(sau)
              if(sau.length) {
                let user = sau[0]
                await db.ref(`quitems/${key}`).update({assigned:true, user:user.key, assigned_at:new Date().getTime()})
                await db.ref(`quusers/${user.key}/q`).push({key})
                if(item.type == 'whatsapp') {
                  let w = await store.collection(`waconversations`).doc(item.db).update({assigned_user:user.key})
                }
                await db.ref(`q/assigned`).transaction(function (current_value) {
                  return (current_value || 0) + 1;
                });
                resolve({status:true, user})
              }
            } else {
              resolve({status: false})
            }
          } catch (error) {
            console.log(error)
            resolve({status: false})
          }
        } else {
          resolve({status: false})
        }
      })
      
    },
		async getUser() {
      let u = await db.ref(`quusers/${this.$props.userData.uid}`).once('value').then(x=>x.val())
      this.user = u
      if(u.punchin.active) {
        this.goTo('/')
      }
    },
    async backReAssign(){
      await axios.get(`${apiBase}/getreAssignAll`).then(x=>x.data)
    },
    async userPunchin() {
      let a = await db.ref(`quusers/${this.$props.userData.uid}/punchin/active`).once('value').then(x=>x.val())
      if(!a) {
        this.user = null
        this.q = []
        this.display_q = []
        await db.ref(`quusers/${this.$props.userData.uid}/punchin`).update({active:true, timestamp:new Date().getTime()})
        await db.ref(`quusers/${this.$props.userData.uid}/`).update({username:this.$props.userName, key:this.$props.userData.uid, wa:this.$props.userData.wa})
        await db.ref(`quuserslogs/${this.$props.userData.uid}/log`).push({timestamp:new Date().getTime(), type:'punchin'})
        this.backReAssign()
        this.sendMessageApi('in')
        this.$emit('snackbarNotification', `Punched In`, 'success')
        this.startTimeOut()
      }
    },
    async backPunchOut(){
      let user = await db.ref(`quusers/${this.$props.userData.uid}`).once('value').then(x=>x.val())
      console.log(user)
      if(user.q) {
        let q = Object.values(user.q).map(x=>x.key)
        await db.ref(`quusers/${this.$props.userData.uid}/`).update({q:null});
        (async x=>{
          for (let i = 0; i < q.length; i++) {
            const key = q[i];
            await db.ref(`quitems/${key}`).update({assigned:false, user:null, assigned_at:null})
            await db.ref(`q/assigned`).transaction(function (current_value) {
              return (current_value || 0) - 1;
            });
          }
        })()
      }
    },
    async userPunchOut(exit, key) {
      this.punchinTime = await db.ref(`quusers/${key ? key :this.$props.userData.uid}/punchin/timestamp`).once('value').then(x=>x.val())
      if(this.punchinTime || exit){
        this.clearTimeOut()
        let pin = await db.ref(`quusers/${key ? key :this.$props.userData.uid}/punchin/timestamp`).once('value').then(x=>x.val())
        this.session = new Date().getTime() - pin
        console.log('session', this.session)
        console.log('session minutes', this.session/1000/60)
        let day = new Date().getDate()
        let month = new Date().getMonth() + 1
        let year = new Date().getFullYear()
        await db.ref(`quusers/${key ? key :this.$props.userData.uid}/punchin`).update({active:false, timestamp:null})
        console.log('---Punchout start-----');
        await db.ref(`quuserslogs/${key ? key :this.$props.userData.uid}/log`).push({timestamp:new Date().getTime(), type:'punchout'})
        console.log('---Punchout end-----');
        await db.ref(`quuserslogs/${key ? key :this.$props.userData.uid}/sessions`).push({session:this.session, day, month, year})
        this.sendMessageApi('out')
        this.backPunchOut()
        this.punchinTime = null
        this.user = null
        this.q = []
        this.display_q = []
        this.$emit('snackbarNotification', `Punched Out`, 'error')
      } else {
        return true
      }
    },
    async getLiveUser() {
      db.ref(`quusers/${this.$props.userData.uid}/punchin`).on('value', x=>{
        this.punchin = x.val()
        this.active = this.punchin ? this.punchin.active : false
      })
      db.ref(`quusers/${this.$props.userData.uid}/q`).on('child_added', x=>{
        let k = x.val().key
        this.q.push(k)
        this.fetchQItem(k, x.key)
      })
    },
    async fetchQItem(key, ukey){
      let item = await db.ref(`quitems/${key}`).once('value').then(x=>x.val())
      let user = await db.ref(`quusers/${this.$props.userData.uid}`).once('value').then(x=>x.val())
      if(item.type == 'whatsapp' && user.wa && user.wa.length && user.wa.includes(item.status)){
        let w = await store.collection(`waconversations`).doc(item.db).get().then(x=>x.data());
        if(user.wa.includes(w.status)) {
          console.log('assigned', item.status, user.wa, w.status, w.number)
          item.key = key
          item.ukey = ukey
          item.d_time = format(item.time)
          item.d_assigned = format(item.assigned_at)
          this.display_q.push({ type:'whatsapp', show:false, item:w, q:item})
        } else {
          console.log('skipped', item.status, user.wa, w.status)
          await db.ref(`quitems/${item.key}`).update({assigned:false, user:null, assigned_at:null, status:w.status})
          await db.ref(`quusers/${item.user}/q/`).update({[item.key]:null})
        }
      } else if(!user.wa.includes(item.status)) {
        console.log('skipped', item.status, user.wa)
        await db.ref(`quitems/${item.key}`).update({assigned:false, user:null, assigned_at:null})
        await db.ref(`quusers/${item.user}/q/`).update({[item.key]:null})
      }
    },
    async qItemDone(item){
      console.log(item)
      await db.ref(`quitems/`).update({[item.q.key]:null})
      await db.ref(`quusers/${item.q.user}/q/`).update({[item.q.ukey]:null})
      await db.ref(`q/q`).transaction(function (current_value) {
        return (current_value || 0) - 1;
      });
      await db.ref(`q/assigned`).transaction(function (current_value) {
        return (current_value || 0) - 1;
      });
    },
    async unAssign(item){
      console.log(item)
      await db.ref(`quitems/${item.q.key}`).update({assigned:false, user:null, assigned_at:null})
      await db.ref(`quusers/${item.q.user}/q/`).update({[item.q.ukey]:null})
      await db.ref(`q/assigned`).transaction(function (current_value) {
        return (current_value || 0) - 1;
      });
    },
    blurScreen() {
      console.log('blured')
    },
    async exitPage() {
      // 
      if(this.newLoad) {
        this.userPunchOut(true)
      }
      // await axios.get(`${apiBase}/`)
    },
    startTimeOut(){
      this.resetTimeout()
      this.registerListereners()
      this.timeoutInterval = setInterval(x=>{
        if(this.timeout>0){
          this.timeout--
          if(this.timeout == (0.5*this.resettimeout)){
            this.$emit('snackbarNotification', `Punch Out in ${this.timeout / 100} seconds`, 'error')
          }
        }
      }, 1)
    },
    async resetTimeout(){
      if(this.timeout < (0.5*this.resettimeout) && this.timeoutInterval) {
        this.$emit('snackbarNotification', `Welcome back`, 'success')
      }
      this.timeout = this.resettimeout * 1
    },
    async monitorLast(){
      let bd = await axios.get('https://us-central1-ashyaatcrm.cloudfunctions.net/main/getDate').then(x=>x.data)
      let bdt = new Date(bd.date).getTime() 
      let bfr = bdt - 3*60*1000
      let u = await db.ref(`quusers`).once('value').then(x=>x.val())
      if(u) {
        let ausers = Object.values(u)
        let users = ausers.filter(x=>x.punchin && x.punchin.last_action && x.punchin.last_action < bfr && ( x.punchin.active || x.q ) )
        console.log(ausers)
        console.log(bfr)

        console.log(users)
        if(users.length){
          (async x=>{
            for (let i = 0; i < users.length; i++) {
              const user = users[i];
              let pin = await db.ref(`quusers/${this.$props.userData.uid}/punchin/timestamp`).once('value').then(x=>x.val())
              let session = new Date().getTime() - pin
              console.log('session', this.session)
              console.log('session minutes', this.session/1000/60)
              let day = new Date().getDate()
              let month = new Date().getMonth() + 1
              let year = new Date().getFullYear()
              await db.ref(`quusers/${this.$props.userData.uid}/punchin`).update({active:false, timestamp:null})
              await db.ref(`quuserslogs/${this.$props.userData.uid}/log`).push({timestamp:new Date().getTime(), type:'punchout'})
              await db.ref(`quuserslogs/${this.$props.userData.uid}/sessions`).push({session:session, day, month, year})
              await db.ref(`quusers/${this.$props.userData.uid}/`).update({q:null});
              if(user.q) {
                let q = Object.values(user.q).map(x=>x.key);
                (async x=>{
                  for (let i = 0; i < q.length; i++) {
                    const key = q[i];
                    await db.ref(`quitems/${key}`).update({assigned:false, user:null, assigned_at:null})
                    await db.ref(`q/assigned`).transaction(function (current_value) {
                      return (current_value || 0) - 1;
                    });
                  }
                })()
              }
            }
          })()
        }
      }
    },
    async storeLast(){
      let last = await db.ref(`quusers/${this.$props.userData.uid}/punchin/last_action`).once('value').then(x=>x.val())
      let bd = await axios.get('https://us-central1-ashyaatcrm.cloudfunctions.net/main/getDate').then(x=>x.data)
      let bdt = new Date(bd.date).getTime()
      let now = new Date().getTime()
      let dif = now - bdt
      let store = now - dif
      console.log(bd)
      console.log(bdt)
      console.log(now)
      console.log(dif)
      console.log(store)
      if(last) {
        console.log((bdt-last)/1000)
      }
      await db.ref(`quusers/${this.$props.userData.uid}/punchin/`).update({last_action:store})
    },
    async deAssignQ(){
      let rQ = await db.ref(`quitems`).orderByChild('assigned').equalTo(true).once('value').then(x=>x.val())
      let u = await db.ref(`quusers`).orderByChild('punchin/active').equalTo(true).once('value').then(x=>x.val())
      if(u){
        let k= Object.keys(u)
        let users = Object.values(u).map((x,i)=>{return{...x,key:k[0]}})
        let qs = [].concat(...users.map(x=>{if(x.q) return Object.values(x.q).map(x=>x.key)}))
        console.log(qs)
        if(rQ){
          let lrQk = Object.keys(rQ)
          let lrQ = Object.values(rQ).map((x, i)=>{return{...x, key:lrQk[i]}})
          let flrQ = lrQ.filter(x=>!qs.includes(x.key));
          (async x=>{
            for (let i = 0; i < flrQ.length; i++) {
              const q = flrQ[i];
              await db.ref(`quitems/${q.key}`).update({assigned:false, user:null, assigned_at:null})
              await db.ref(`q/assigned`).transaction(function (current_value) {
                return (current_value || 0) - 1;
              });
            }
          })()
        }
      }
    },
    clearTimeOut(){
      this.resetTimeout()
      clearInterval(this.timeoutInterval)
      var events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
      events.forEach((name) => {
        document.removeEventListener(name, this.resetTimeout, true)
        document.removeEventListener(name, this.storeLast, true)
      });
    },
    registerListereners(){
      var events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
      events.forEach((name) => {
        document.addEventListener(name, this.resetTimeout, true); 
        if(name == 'mousedown' || name == 'keypress') {
          document.addEventListener(name, this.storeLast, true); 
        }
      });
    },
    async getCounters(){
      await db.ref('q').on('value', x=>{
        let v = x.val()
        this.counters = v
        // if(this.counters.q < 1) {
        //   this.userPunchOut()
        // }
      })
    },
    async resetCounters(){
      let k = Object.keys(this.counters);
      (async x=>{
        for (let i = 0; i < k.length; i++) {
          const key = k[i];
          await db.ref('q').update({[key]:0})
        }
        this.$emit('snackbarNotification', `Counters Reset`, 'success')

      })()
    },
    async resetGrandQ() {
      this.resetCounters()
      await db.ref(`quitems`).set(null)
      this.$emit('snackbarNotification', `Q Reset`, 'success')
    },
    async resetQ(){
      await db.ref(`quitems`).set(null)
      this.$emit('snackbarNotification', `Q Reset`, 'success')
    },
    async monitorUsers(){
      if(this.$props.superAdmin || this.$props.userRole == 'admin') {
        db.ref(`quusers`).on('value', x=>{
          this.users = x.val()
        })
      }
    },
    async loadQUser() {
      this.loading = true
      console.log(this.selectedUser.key)
      this.loadedUser = await db.ref(`quusers/${this.selectedUser.key}`).once('value').then(x=>x.val())
      console.log(this.loadedUser)
      this.adminPanel = true
      this.loading = false
    },
    async getAllUsers(){
      this.loading = true
      let a = await db.ref('users').once('value').then(x=>x.val())
      console.log(a)
      // 
      let b = Object.keys(a)
      let c = Object.values(a).map((d, i)=>{
        return {
          ...d,
          key:b[i]
        }
      })
      this.ousers = c;
      (async x => {
        for (let i = 0; i < c.length; i++) {
          const user = c[i];
          await db.ref(`quusers/${user.key}/`).update({log:null, sessions:null})
        }
      })()
      this.loading = false
    },
    async statusCheck(){
      var connectedRef = firebase.database().ref(".info/connected");
      connectedRef.on("value", async (snap) => {
        if (snap.val() === true) {
        } else {
      		await db.ref(`quusers/${this.$props.userData.uid}/punchin`).update({active:false, timestamp:null})
        }
      });
      let updateIndicator = async () => {
        if(navigator.onLine) { // true|false
        } else {
      		await db.ref(`quusers/${this.$props.userData.uid}/punchin`).update({active:false, timestamp:null})
        }
      }
      window.addEventListener('online',  updateIndicator);
      window.addEventListener('offline', updateIndicator);
    },
    async sendMessageApi(punch){
      try {
        await db.ref(`quuserslogs/${this.$props.userData.uid}/wlog`).push({timestamp:new Date().getTime(), type:`punch${punch}`})
      } catch (error) {}
      let post = {
        number: '962785219523',
        country: 'Ashyaat Jordan',
        message: `${this.$props.userName} punched ${punch}`,
        user: 'Q SYSTEM',
      }
      // let send = await axios.post(`// WA API //`, post, {headers:headers}).then(x=>x.data)
      // if(send.success) {
      // } else if(send.qr){
      //   this.$emit('snackbarNotification', `Please scan ${send.number} QR code`, 'error')
      // } else {
      //   this.$emit('snackbarNotification', `${send.number?send.number:''} ${send.message}`, 'error')
      // }
      
    },
    goTo(path) {
      this.$router.push(path)
    },
    async singleWindow(){
      let a = localStorage.getItem("ashyaat")
      let b = await db.ref(`quusers/${this.$props.userData.uid}/current`).once('value').then(x=>x.val())
      console.log(a)
      console.log(b)
      console.log(window.name)
      if(this.beta) {
        if(a && a == b && window.name != a ) {
          console.log(localStorage.getItem("ashyaat"));
          this.goTo('/')
        } else {
          let c = this.genKey('SESSION')
          window.name = c
          localStorage.setItem("ashyaat", c);
          await db.ref(`quusers/${this.$props.userData.uid}/`).update({ current: c })
        }
      }
    },
    exportData(data, name){
      let a = json2csv.parse(data)
      console.log(a)
      let csvContent = "data:text/csv;charset=utf-8," 
      var encodedUri =  csvContent + encodeURIComponent(a);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      let n = name ? name : 'leads_export'
      link.setAttribute("download", `${n}.csv`);
      document.body.appendChild(link); // Required for FF

      link.click();
    },
    async exportUserWTime(user) {
      console.log(user)
      let cc = await db.ref(`quuserslogs/${user.key}/wlog`).once('value').then(x=>x.val())
      console.log(cc)
      let a = Object.values(cc)
      let b = a.map(x=>{
        return {
          ...x,
          date_time: new Date(new Date(x.timestamp).getTime()+2*60*60*1000).toISOString()
        }
      })
      this.exportData(b, `${user.username}-w-${new Date().toISOString()}`)
    },
    async exportUserDaily(user) {
      let cc = await db.ref(`quusers/${user.key}/msgs`).once('value').then(x=>x.val())
      console.log(cc)
      let a = Object.values(cc)
      let c = Object.keys(cc)
      let b = a.map((x, i)=>{
        return {
          day:c[i].split('-')[0],
          month:c[i].split('-')[1],
          count:x
        }
      })
      this.exportData(b, `${user.username}-w-${new Date().toISOString()}`)
    },
    async exportUserTime(user) {
      console.log(user)
      let cc = await db.ref(`quuserslogs/${user.key}/log`).once('value').then(x=>x.val())
      console.log(cc)
      let a = Object.values(cc)
      let b = a.map(x=>{
        return {
          ...x,
          date_time: new Date(new Date(x.timestamp).getTime()+2*60*60*1000).toISOString()
        }
      })
      this.exportData(b, `${user.username}-${new Date().toISOString()}`)
    },
    async getConv(it) {
      this.live_q[it.key].w = await store.collection(`waconversations`).doc(it.db).get().then(x=>x.data());
    },
    async realTimeQ(){
      if((this.$props.superAdmin || this.$props.userRole == 'admin')) {
        db.ref(`quitems`).on('child_changed', async x=>{
          let q_i = x.val()
          
          this.live_q[q_i.key] = x.val()

          console.log(this.live_q)
        })
      }
    },
    async deleteComment(comment){
      return new Promise(async (res, rej)=>{
        res(true)
      })
    },
    async hideComment(comment){
      return new Promise(async (res, rej)=>{
        res(true)
      })
    },
    async testFBQ(){
      // await db.ref('settings').update({fbhooktest:null})
      let hidePhrases_ = await db.ref('settings/hidePhrases').once('value').then(x=>x.val())
      let deletePhrases_ = await db.ref('settings/deletePhrases').once('value').then(x=>x.val())
      let hidePhrases = Object.values(hidePhrases_)
      let deletePhrases = Object.values(deletePhrases_)
      let fbhooktest =  await db.ref('settings/fbhooktest').once('value').then(x=>x.val())
      let a = Object.values(fbhooktest)
      for (let i = 0; i < a.length; i++) {
        const d = a[i];
        if(d.object == 'page') {
          let page_id = d.entry[0].id
          console.log('page_id', page_id)
          if(d.entry[0].changes && d.entry[0].changes[0].value.post && d.entry[0].changes[0].value.post.id && d.entry[0].changes[0].value.item == 'comment' && false) {

            let comment = {
              page:d.entry[0].id,
              from:d.entry[0].changes[0].value.from.id,
              me: d.entry[0].changes[0].value.from.id === d.entry[0].id ? true : false,
              post: d.entry[0].changes[0].value.post.id,
              post_id: d.entry[0].changes[0].value.post.id.replace(`${d.entry[0].id}_`, ''),
              comment: d.entry[0].changes[0].value.comment_id,
              from: d.entry[0].changes[0].value.from.name,
              comment_id: d.entry[0].changes[0].value.comment_id.replace( d.entry[0].changes[0].value.post.id.replace(`${d.entry[0].id}_`, '') + '_' , ''),
              text: d.entry[0].changes[0].value.message,
              top: d.entry[0].changes[0].value.parent_id == d.entry[0].changes[0].value.post.id,
              new: d.entry[0].changes[0].value.verb == 'add' ? true : false,
              link: d.entry[0].changes[0].value.post.permalink_url
            }
            let token = await db.ref(`settings/fb/${comment.page}/token`).once('value').then(x=>x.val())
            console.log('comment', comment)
            function sendMesage(comment, message){
              return new Promise(async (res, rej)=>{
                let message = {
                  recipient:comment,
                  messaging_type:'RESPONSE',
                  message:{text:message}
                }
                let b = await axios.post(`https://graph.facebook.com/v11.0/me/messages?access_token=${token}`, message).then(x=>x.data)
                res(b)
              })
            }
            function deleteComment(comment){
              return new Promise(async (res, rej)=>{
                let message = deletePhrases.filter(x=> comment.text.includes(x.phrase))[0].message
                await sendMesage(comment, message)
                let d = await axios.delete(`https://graph.facebook.com/${comment.comment}?access_token=${token}`).then(x=>x.data)
                console.log('delete resp', d)
                res(true)
              })
            }
            function hideComment(comment){
              return new Promise(async (res, rej)=>{
                
                let message = hidePhrases.filter(x=> comment.text.includes(x.phrase))[0].message
                await sendMesage(comment, message)
                let d = await axios.post(`https://graph.facebook.com/${comment.comment}?access_token=${token}&is_hidden=true`).then(x=>x.data)
                console.log('hide resp', d)
                res(true)
              })
            }
            function filterComments(comment){
              return new Promise(async (res, rej)=>{
                let terms_delete = deletePhrases.map(x=>x.phrase)
                let terms_hide = hidePhrases.map(x=>x.phrase)
                let delete_check = terms_delete.length && comment.text && comment.text != '' && terms_delete.some(x=> comment.text.includes(x))
                let hide_check = terms_hide.length && comment.text && comment.text != '' && terms_hide.some(x=> comment.text.includes(x))
                if(delete_check) {
                  await deleteComment(comment)
                  res(true)
                } else if(hide_check){
                  await hideComment(comment)
                  res(true)
                } else {
                  res(false)
                }
              })
            }
            let filter_comments = await filterComments(comment)
            if(!filter_comments) {
              let comment_store = await store.collection('fb_comments').add(comment)
              let qitem = {
                type:'facebook_comment',
                assigned:false,
                open:false,
                db:comment_store.id,
                title: 'New Comment',
                time: new Date().getTime(),
                timestamp: new Date().getTime(),
                timezone:  new Date().getTimezoneOffset(),
                status: 'NEW'
              }
              if(this.$props.beta) {
                this.display_q.push({ type:'facebook_comment', show:false, comment:false, post:false, item:comment, q:qitem})
              }
            }
          }
          if(d.entry[0].messaging && d.entry[0].messaging[0].reaction  && false){
            console.log('reaction', d)
          }
          let beta = this.$props.beta
          let qq = []
          function pushFBToQ(convo){
            return new Promise(async (res, rej)=>{
              let qitem = {
                type:'facebook_message',
                assigned:false,
                open:false,
                db:convo.key,
                title: 'New Message',
                time: new Date().getTime(),
                timestamp: new Date().getTime(),
                timezone:  new Date().getTimezoneOffset(),
                status: 'NEW'
              }
              if(beta) {
                qq.push({ type:'facebook_message', show:false, item:convo, q:qitem})
              }
              res(true)
            })
          }
          if(d.entry[0].messaging && d.entry[0].messaging[0].message){
            console.log('message', d)
            console.log('message >', d.entry[0].messaging[0].message.text)
            let msg = {
              timestamp:d.entry[0].time,
              me: d.entry[0].messaging[0].sender.id === page_id ? true : false
            }
            if(d.entry[0].messaging[0].message.text) {
              msg.text = d.entry[0].messaging[0].message.text
            } else if(d.entry[0].messaging[0].message.attachments){
              msg.attachments = d.entry[0].messaging[0].message.attachments
            }
            if(msg.me) {
              let f = await db.ref(`FBnuser/${d.entry[0].messaging[0].message.mid.slice(0, 20)}/user`).once('value').then(x=>x.val())
              if (f) {
                msg.user = f
              }
            }
            
            let convo = {
              sender: d.entry[0].messaging[0].sender.id,
              recipient: d.entry[0].messaging[0].recipient.id,
              customer: msg.me ? d.entry[0].messaging[0].recipient.id : d.entry[0].messaging[0].sender.id,
              last_message: msg.timestamp,
              need: msg.me ? false : true,
              page_id
            }
            let check_convo = await store.collection(`fbconversations`).where('customer', '==', convo.customer)
            .get()
            .then(x => x.docs.map(y => {
              return {
                ...y.data(),
                key: y.id
              }
            })).catch(err=>console.log('err search', err));
            let old_convo = check_convo && check_convo.length ? check_convo[0] : null
            if(old_convo) {
              console.log('old_convo')
              convo.key = old_convo.key
              if(!convo.status) {
                convo.status = 'N/A'
              }
              await store.collection(`fbconversations`).doc(old_convo.key).update(convo)
              await store.collection(`fbconversations`).doc(old_convo.key).collection('messages').add(msg)
              if(convo.need || true) {
                await pushFBToQ(convo)
              }
            } else {
              console.log('new_convo')
              let new_convo = await store.collection(`fbconversations`).add(convo)
              convo.key = new_convo.id
              convo.status = 'N/A'
              await store.collection(`fbconversations`).doc(new_convo.id).collection('messages').add(msg)
              if(convo.need || true) {
                await pushFBToQ(convo)
              }
            }
            this.display_q = qq
            
            console.log('sorted display_q', this.display_q)
            console.log('sorted message', msg)
          }
        } 
        if(d.object == 'instagram' && false) {
          if(d.entry[0].changes && d.entry[0].changes[0].field == 'comments') {
            console.log('comment_details', d)
            let comment_details = await axios.get(`https://graph.facebook.com/${d.entry[0].changes[0].value.id}?fields=id,media&access_token=${localStorage.fb_token}`).then(x=>x.data).catch(x=>null)
            console.log('comment_details', comment_details)
            if(comment_details) {
              // let instacheck = await axios.get(`https://graph.instagram.com/v11.0/me?access_token=${localStorage.fb_token}`).then(x=>x.data).catch(x=>null)
              // console.log('instacheck', instacheck)
              // let media_details = await axios.get(`https://graph.instagram.com/${comment_details.media.id}/?fields=caption,media_url,permalink,username&access_token=${localStorage.fb_token}`).then(x=>x.data).catch(x=>null)
              let comment = {
                page:d.entry[0].id,
                comment_id: d.entry[0].changes[0].value.id,
                text: d.entry[0].changes[0].value.text,
                media: comment_details.media.id,
                media_code: instagramIdToUrlSegment(comment_details.media.id),
                // ...media_details
              }
              console.log('instagram comment', d, comment)
              function deleteComment(comment){
                return new Promise(async (res, rej)=>{
                  res(true)
                })
              }
              function hideComment(comment){
                return new Promise(async (res, rej)=>{
                  res(true)
                })
              }
              function filterComments(comment){
                return new Promise(async (res, rej)=>{
                  let terms_delete = []
                  let terms_hide = []
                  let delete_check = terms_delete.length && comment.text && comment.text != '' && terms_delete.some(x=> comment.text.includes(x))
                  let hide_check = terms_hide.length && comment.text && comment.text != '' && terms_hide.some(x=> comment.text.includes(x))
                  if(delete_check) {
                    await deleteComment(comment)
                    res(true)
                  } else if(hide_check){
                    await hideComment(comment)
                    res(true)
                  } else {
                    res(false)
                  }
                })
              }
              if(!await filterComments(comment)) {
                let qitem = {
                  type:'instagram_comment',
                  assigned:false,
                  open:false,
                  title: 'New Comment',
                  time: new Date().getTime(),
                  timestamp: new Date().getTime(),
                  timezone:  new Date().getTimezoneOffset(),
                  status: 'NEW'
                }
                if(this.$props.beta) {
                  this.display_q.push({ type:'instagram_comment', show:false, comment:false, post:false, item:comment, q:qitem})
                }
              }
            }
          } else {
            console.log('instagram message', d)
          }
        }
      }
      console.log('fbhooktest', a)
    },
    async facebookRefresh(id){
      console.log(id)
      console.log(FB)
      await sleep(500)
      FB.XFBML.parse(document.getElementById(id))
    },
    async renderFB(ob, i){
      this.facebookRefresh(ob.item.post_id + '-post-' + i);
      await  sleep(500)
      this.facebookRefresh(ob.item.post_id + '-comment-' + i)
    },
    async checkFB(){
      return new Promise(async (res, rej)=>{
        let token = await db.ref('settings/fb/long_token').once('value').then(x=>x.val())
        FB.api('/me', (response) => {
          console.log('me', response);
          if(response.name) {
            this.FBON = true
            localStorage.fb_token = token
          }
          console.log('Good to see you, ' + response.name + '.');
          res(true)
          return response
        }, {access_token:token});
        let p_acc = await axios.get(`https://graph.facebook.com/1452405111716864?fields=access_token&access_token=${token}`).then(x=>x.data)
        console.log(p_acc)
        await db.ref('settings/fb/1452405111716864').update({token:p_acc.access_token})
      })
    },
    async openFBLink(link){
      window.open(link, '_blank').blur();
      window.focus()
    },
    async sendReply(item) {
      console.log(item)
      let token = await db.ref(`settings/fb/${item.page}/token`).once('value').then(x=>x.val())
      let comment = {
        message: item.reply
      }
      let message = {
        recipient:item.comment,
        messaging_type:'RESPONSE',
        message:{text:item.message}
      }
      let a = await axios.post(`https://graph.facebook.com/${item.comment}/comments?access_token=${token}`, comment).then(x=>x.data)
      let b = await axios.post(`https://graph.facebook.com/v11.0/me/messages?access_token=${token}`, message).then(x=>x.data)
      console.log(a)
      console.log(b)
      let comment_id = a.id.replace(`${item.post_id}_`, '')
      let history = {
        comment_id,
        user: this.$props.userName,
        uid: this.$props.userData.user_id,
        timestamp: new Date().getTime()
      }

      console.log(history)
    }
  },
  props:{
		userName:{
			default:null
    },
    userRole: {
      required: true,
      default: 'user'
    },
    beta: {
      required: true,
      default: false
    },
    superAdmin: {
      required: true,
      default: false
    },
    userData : {
      default: false

    }
  },
  computed:{
    display_q_sort(){
      return this.display_q.sort((a,b)=> b.q.time - a.q.time)
    }
  },
  watch:{
    timeout(){
      if(this.timeout  == 1 && this.punchinTime) {
        this.userPunchOut()
      }
    }
  },
  async created(){
    await this.checkFB()
    this.testFBQ()
    this.singleWindow()
    this.monitorLast()
    this.getCounters()
    this.getUser()
    this.getLiveUser()
    this.getAllUsers()
    this.monitorUsers()
    
    // this.statusCheck()
    // window.addEventListener('beforeunload', this.exitPage())
    this.newLoad = true
    // document.addEventListener("visibilitychange", x=> {
    //     if (document.hidden){
    //         this.blurScreen()
    //     } else {
    //         console.log("Browser tab is visible")
    //     }
    // });
  },
  mounted(){

  }
}
</script>

<style>
.tokenField * {
  color:white !important;
}
</style>
